//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL_STORE = new InjectionToken<string>('API_BASE_URL_STORE');

@Injectable()
export class CountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a list of all countries from system
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param _filterid (optional) Filter by country id
     * @param _filteralpha2 (optional) Filter by country ISO code
     * @return A list of countries
     */
    country(expand: Expand | undefined, page: number | undefined, _filterid: number | undefined, _filteralpha2: string | undefined): Observable<Anonymous> {
        let url_ = this.baseUrl + "/v1/country?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (_filterid === null)
            throw new Error("The parameter '_filterid' cannot be null.");
        else if (_filterid !== undefined)
            url_ += "_filter[id]=" + encodeURIComponent("" + _filterid) + "&";
        if (_filteralpha2 === null)
            throw new Error("The parameter '_filteralpha2' cannot be null.");
        else if (_filteralpha2 !== undefined)
            url_ += "_filter[alpha2]=" + encodeURIComponent("" + _filteralpha2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processCountry(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request data", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a list of all orders
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param per_page (optional) Number of items per page
     * @param sort (optional) Sorting. Available fields - id, total_amount, create_date. E.g. id - sort asc, -id - sort desc.
     * @param _filterq (optional) Filter by multiple fields - Order Id or Email or Tracking number or Total amount
     * @param _filterid (optional) Filter by order id
     * @param _filteruser_id (optional) Filter by user id
     * @param _filtertotal_amount (optional) Filter by order total amount
     * @param _filtertracking_number (optional) Filter by tracking number
     * @param _filterstatus (optional) Filter by order status
     * @param _filteremail (optional) Filter by user email
     * @param _filterdateFrom (optional) Filtering from date
     * @param _filterdateTo (optional) Filtering to date
     * @return A list of orders
     */
    order(expand: Expand2 | undefined, page: number | undefined, per_page: number | undefined, sort: string | undefined, _filterq: string | undefined, _filterid: number | undefined, _filteruser_id: number | undefined, _filtertotal_amount: number | undefined, _filtertracking_number: string | undefined, _filterstatus: number | undefined, _filteremail: string | undefined, _filterdateFrom: string | undefined, _filterdateTo: string | undefined): Observable<Anonymous2> {
        let url_ = this.baseUrl + "/v1/order?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (per_page === null)
            throw new Error("The parameter 'per_page' cannot be null.");
        else if (per_page !== undefined)
            url_ += "per-page=" + encodeURIComponent("" + per_page) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (_filterq === null)
            throw new Error("The parameter '_filterq' cannot be null.");
        else if (_filterq !== undefined)
            url_ += "_filter[q]=" + encodeURIComponent("" + _filterq) + "&";
        if (_filterid === null)
            throw new Error("The parameter '_filterid' cannot be null.");
        else if (_filterid !== undefined)
            url_ += "_filter[id]=" + encodeURIComponent("" + _filterid) + "&";
        if (_filteruser_id === null)
            throw new Error("The parameter '_filteruser_id' cannot be null.");
        else if (_filteruser_id !== undefined)
            url_ += "_filter[user_id]=" + encodeURIComponent("" + _filteruser_id) + "&";
        if (_filtertotal_amount === null)
            throw new Error("The parameter '_filtertotal_amount' cannot be null.");
        else if (_filtertotal_amount !== undefined)
            url_ += "_filter[total_amount]=" + encodeURIComponent("" + _filtertotal_amount) + "&";
        if (_filtertracking_number === null)
            throw new Error("The parameter '_filtertracking_number' cannot be null.");
        else if (_filtertracking_number !== undefined)
            url_ += "_filter[tracking_number]=" + encodeURIComponent("" + _filtertracking_number) + "&";
        if (_filterstatus === null)
            throw new Error("The parameter '_filterstatus' cannot be null.");
        else if (_filterstatus !== undefined)
            url_ += "_filter[status]=" + encodeURIComponent("" + _filterstatus) + "&";
        if (_filteremail === null)
            throw new Error("The parameter '_filteremail' cannot be null.");
        else if (_filteremail !== undefined)
            url_ += "_filter[email]=" + encodeURIComponent("" + _filteremail) + "&";
        if (_filterdateFrom === null)
            throw new Error("The parameter '_filterdateFrom' cannot be null.");
        else if (_filterdateFrom !== undefined)
            url_ += "_filter[dateFrom]=" + encodeURIComponent("" + _filterdateFrom) + "&";
        if (_filterdateTo === null)
            throw new Error("The parameter '_filterdateTo' cannot be null.");
        else if (_filterdateTo !== undefined)
            url_ += "_filter[dateTo]=" + encodeURIComponent("" + _filterdateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous2>;
        }));
    }

    protected processOrder(response: HttpResponseBase): Observable<Anonymous2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request data", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrive an order
     * @param id Pre-order id
     * @param expand (optional) Includes requested nested objects
     * @return Order
     */
    order2(id: number, expand: Expand3 | undefined): Observable<Order> {
        let url_ = this.baseUrl + "/v1/order/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Order>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Order>;
        }));
    }

    protected processOrder2(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Order approval
     * @param id Order id
     * @param revision Order revision
     * @return Successful operation
     */
    approve(id: number, revision: number): Observable<Order> {
        let url_ = this.baseUrl + "/v1/order/approve/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined and cannot be null.");
        else
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Order>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Order>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(HttpException.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData412)) {
                result412 = [] as any;
                for (let item of resultData412)
                    result412!.push(HttpException.fromJS(item));
            }
            else {
                result412 = <any>null;
            }
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancellation of pre-order
     * @param id Pre-order id
     * @param revision Order revision
     * @return Successful operation
     */
    refund(id: number, revision: number): Observable<Order> {
        let url_ = this.baseUrl + "/v1/order/refund/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined and cannot be null.");
        else
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Order>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Order>;
        }));
    }

    protected processRefund(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(HttpException.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData412)) {
                result412 = [] as any;
                for (let item of resultData412)
                    result412!.push(HttpException.fromJS(item));
            }
            else {
                result412 = <any>null;
            }
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a list of all products
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param _filtername (optional) Filter by product name
     * @return A list of products
     */
    product(expand: Expand4 | undefined, page: number | undefined, _filtername: string | undefined): Observable<Anonymous3> {
        let url_ = this.baseUrl + "/v1/product?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (_filtername === null)
            throw new Error("The parameter '_filtername' cannot be null.");
        else if (_filtername !== undefined)
            url_ += "_filter[name]=" + encodeURIComponent("" + _filtername) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous3>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous3>;
        }));
    }

    protected processProduct(response: HttpResponseBase): Observable<Anonymous3> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous3.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrive a product
     * @param id Product id
     * @param expand (optional) Includes requested nested objects
     * @return Product object
     */
    productAllGET(id: number, expand: Expand5 | undefined): Observable<Product[]> {
        let url_ = this.baseUrl + "/v1/product/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductAllGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductAllGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processProductAllGET(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a product
     * @param id Product id
     * @param revision Product revision
     * @return Product object
     */
    productAllPATCH(id: number, revision: number): Observable<Product[]> {
        let url_ = this.baseUrl + "/v1/product/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined and cannot be null.");
        else
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductAllPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductAllPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processProductAllPATCH(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData412)) {
                result412 = [] as any;
                for (let item of resultData412)
                    result412!.push(HttpException.fromJS(item));
            }
            else {
                result412 = <any>null;
            }
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductVariantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a product variant
     * @param id Product Variant id
     * @param expand (optional) Includes requested nested objects
     * @return ProductVariant object
     */
    productVariant(id: number, expand: Expand6 | undefined): Observable<ProductVariant[]> {
        let url_ = this.baseUrl + "/v1/product-variant/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariant[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariant[]>;
        }));
    }

    protected processProductVariant(response: HttpResponseBase): Observable<ProductVariant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariant.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive all reviews
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param per_page (optional) Number of items per page
     * @param sort (optional) Sorting. Available fields - id, status, star_count, create_date. E.g. id - sort asc, -id - sort desc.
     * @param _filterproduct_id (optional) Filter by product id
     * @param _filteruser_id (optional) Filter by user id
     * @param _filterstar_count (optional) Filter by stars
     * @param _filterstatus (optional) Filter by review status
     * @param _filterdateFrom (optional) Filtering from date
     * @param _filterdateTo (optional) Filtering to date
     * @return A list of reviews
     */
    review(expand: Expand7 | undefined, page: number | undefined, per_page: number | undefined, sort: string | undefined, _filterproduct_id: number | undefined, _filteruser_id: number | undefined, _filterstar_count: number | undefined, _filterstatus: number | undefined, _filterdateFrom: string | undefined, _filterdateTo: string | undefined): Observable<Anonymous4> {
        let url_ = this.baseUrl + "/v1/review?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (per_page === null)
            throw new Error("The parameter 'per_page' cannot be null.");
        else if (per_page !== undefined)
            url_ += "per-page=" + encodeURIComponent("" + per_page) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (_filterproduct_id === null)
            throw new Error("The parameter '_filterproduct_id' cannot be null.");
        else if (_filterproduct_id !== undefined)
            url_ += "_filter[product_id]=" + encodeURIComponent("" + _filterproduct_id) + "&";
        if (_filteruser_id === null)
            throw new Error("The parameter '_filteruser_id' cannot be null.");
        else if (_filteruser_id !== undefined)
            url_ += "_filter[user_id]=" + encodeURIComponent("" + _filteruser_id) + "&";
        if (_filterstar_count === null)
            throw new Error("The parameter '_filterstar_count' cannot be null.");
        else if (_filterstar_count !== undefined)
            url_ += "_filter[star_count]=" + encodeURIComponent("" + _filterstar_count) + "&";
        if (_filterstatus === null)
            throw new Error("The parameter '_filterstatus' cannot be null.");
        else if (_filterstatus !== undefined)
            url_ += "_filter[status]=" + encodeURIComponent("" + _filterstatus) + "&";
        if (_filterdateFrom === null)
            throw new Error("The parameter '_filterdateFrom' cannot be null.");
        else if (_filterdateFrom !== undefined)
            url_ += "_filter[dateFrom]=" + encodeURIComponent("" + _filterdateFrom) + "&";
        if (_filterdateTo === null)
            throw new Error("The parameter '_filterdateTo' cannot be null.");
        else if (_filterdateTo !== undefined)
            url_ += "_filter[dateTo]=" + encodeURIComponent("" + _filterdateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous4>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous4>;
        }));
    }

    protected processReview(response: HttpResponseBase): Observable<Anonymous4> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous4.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request data", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change review status
     * @param id Review id
     * @return Updated review object
     */
    changeStatus(id: number, body: Body): Observable<Review> {
        let url_ = this.baseUrl + "/v1/review/change-status?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Review>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Review>;
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<Review> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Review.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReviewAttachmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Delete a review attachment
     * @param id ReviewAttachment id
     * @return No Content
     */
    reviewAttachment(id: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/review-attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReviewAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReviewAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReviewAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a list of all uom from system
     * @param page (optional) Page number
     * @param _filtershort_name (optional) Filter by uom short name
     * @return A list of uom
     */
    uom(page: number | undefined, _filtershort_name: string | undefined): Observable<Anonymous5> {
        let url_ = this.baseUrl + "/v1/uom?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (_filtershort_name === null)
            throw new Error("The parameter '_filtershort_name' cannot be null.");
        else if (_filtershort_name !== undefined)
            url_ += "_filter[short_name]=" + encodeURIComponent("" + _filtershort_name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous5>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous5>;
        }));
    }

    protected processUom(response: HttpResponseBase): Observable<Anonymous5> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous5.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductReserveClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrieve a list of all reserves
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param _filteruser_email (optional) Filter by user email
     * @param _filterproduct_variant_id (optional) Filter by product variant ID
     * @param _filterstatus (optional) Filter by product reserve status
     * @return A list of product reserves
     */
    productReserveGET(expand: Expand8 | undefined, page: number | undefined, _filteruser_email: string | undefined, _filterproduct_variant_id: number | undefined, _filterstatus: number | undefined): Observable<Anonymous6> {
        let url_ = this.baseUrl + "/v1/product-reserve?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (_filteruser_email === null)
            throw new Error("The parameter '_filteruser_email' cannot be null.");
        else if (_filteruser_email !== undefined)
            url_ += "_filter[user_email]=" + encodeURIComponent("" + _filteruser_email) + "&";
        if (_filterproduct_variant_id === null)
            throw new Error("The parameter '_filterproduct_variant_id' cannot be null.");
        else if (_filterproduct_variant_id !== undefined)
            url_ += "_filter[product_variant_id]=" + encodeURIComponent("" + _filterproduct_variant_id) + "&";
        if (_filterstatus === null)
            throw new Error("The parameter '_filterstatus' cannot be null.");
        else if (_filterstatus !== undefined)
            url_ += "_filter[status]=" + encodeURIComponent("" + _filterstatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductReserveGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductReserveGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous6>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous6>;
        }));
    }

    protected processProductReserveGET(response: HttpResponseBase): Observable<Anonymous6> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous6.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request data", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a reserve
     * @param id ProductReserve id
     * @return No Content
     */
    productReserveDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/product-reserve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductReserveDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductReserveDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductReserveDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_STORE) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrive a list of all users
     * @param expand (optional) Includes requested nested objects
     * @param page (optional) Page number
     * @param _filteremail (optional) Filter by user email
     * @return A list of users
     */
    userGET(expand: Expand9 | undefined, page: number | undefined, _filteremail: string | undefined): Observable<Anonymous7> {
        let url_ = this.baseUrl + "/v1/user?";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (_filteremail === null)
            throw new Error("The parameter '_filteremail' cannot be null.");
        else if (_filteremail !== undefined)
            url_ += "_filter[email]=" + encodeURIComponent("" + _filteremail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous7>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous7>;
        }));
    }

    protected processUserGET(response: HttpResponseBase): Observable<Anonymous7> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous7.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrive a user
     * @param id User id
     * @param expand (optional) Includes requested nested objects
     * @return User object
     */
    userAll(id: number, expand: Expand10 | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/v1/user/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processUserAll(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a user
     * @param id User id
     * @param revision User revision
     * @return No Content
     */
    userDELETE(id: number, revision: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/user/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined and cannot be null.");
        else
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData412)) {
                result412 = [] as any;
                for (let item of resultData412)
                    result412!.push(HttpException.fromJS(item));
            }
            else {
                result412 = <any>null;
            }
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ban a user
     * @param id User id
     * @param revision User revision
     * @return No Content
     */
    ban(id: number, revision: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/user/ban/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined and cannot be null.");
        else
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData401)) {
                result401 = [] as any;
                for (let item of resultData401)
                    result401!.push(HttpException.fromJS(item));
            }
            else {
                result401 = <any>null;
            }
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404)
                    result404!.push(HttpException.fromJS(item));
            }
            else {
                result404 = <any>null;
            }
            return throwException("The specified resource was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result412: any = null;
            let resultData412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData412)) {
                result412 = [] as any;
                for (let item of resultData412)
                    result412!.push(HttpException.fromJS(item));
            }
            else {
                result412 = <any>null;
            }
            return throwException("Precondition Failed", status, _responseText, _headers, result412);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Area implements IArea {
    id?: number;
    country_id?: number;
    name?: string;
    alpha?: string;

    [key: string]: any;

    constructor(data?: IArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.country_id = _data["country_id"];
            this.name = _data["name"];
            this.alpha = _data["alpha"];
        }
    }

    static fromJS(data: any): Area {
        data = typeof data === 'object' ? data : {};
        let result = new Area();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["country_id"] = this.country_id;
        data["name"] = this.name;
        data["alpha"] = this.alpha;
        return data;
    }
}

export interface IArea {
    id?: number;
    country_id?: number;
    name?: string;
    alpha?: string;

    [key: string]: any;
}

export class Avatar implements IAvatar {
    id?: number;
    name?: string;
    image?: string;
    sort?: number;

    [key: string]: any;

    constructor(data?: IAvatar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): Avatar {
        data = typeof data === 'object' ? data : {};
        let result = new Avatar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IAvatar {
    id?: number;
    name?: string;
    image?: string;
    sort?: number;

    [key: string]: any;
}

export class Country implements ICountry {
    id?: number;
    name?: string;
    alpha2?: string;
    alpha3?: string;
    areas?: Area[];

    [key: string]: any;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.alpha2 = _data["alpha2"];
            this.alpha3 = _data["alpha3"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(Area.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["alpha2"] = this.alpha2;
        data["alpha3"] = this.alpha3;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountry {
    id?: number;
    name?: string;
    alpha2?: string;
    alpha3?: string;
    areas?: Area[];

    [key: string]: any;
}

export class Courier implements ICourier {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ICourier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Courier {
        data = typeof data === 'object' ? data : {};
        let result = new Courier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICourier {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class Locality implements ILocality {
    id?: number;
    country_id?: number;
    area_id?: number;
    name?: number;

    [key: string]: any;

    constructor(data?: ILocality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.country_id = _data["country_id"];
            this.area_id = _data["area_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Locality {
        data = typeof data === 'object' ? data : {};
        let result = new Locality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["country_id"] = this.country_id;
        data["area_id"] = this.area_id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocality {
    id?: number;
    country_id?: number;
    area_id?: number;
    name?: number;

    [key: string]: any;
}

export class Order implements IOrder {
    readonly id?: number;
    external_id?: string | undefined;
    user_id?: number;
    shipping_address_id?: number;
    billing_address_id?: number;
    shipping_option_id?: number;
    shipping_amount?: number;
    total_amount?: number;
    tracking_number?: string;
    tracking_url?: string;
    /** `1` Purchase

`2` Pre-order
 */
    type?: OrderType;
    timezone?: string;
    revision?: number;
    /** `1` Pending approve

`2` Processing

`3` Canceled

`4` Fulfillment error

`5` Pending fulfullment

`6` Fulfilled

`7` Out for delivery

`8` In transit

`9` Completed

`10` Partially returned

`11` Returned
 */
    status?: OrderStatus;
    complete_date?: string | undefined;
    create_date?: string;
    update_date?: string;
    lines?: OrderLine[];
    user?: User;
    billingAddress?: UserAddress;
    shippingAddress?: UserAddress;
    shippingOption?: ShippingOption;

    [key: string]: any;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            (<any>this).id = _data["id"];
            this.external_id = _data["external_id"];
            this.user_id = _data["user_id"];
            this.shipping_address_id = _data["shipping_address_id"];
            this.billing_address_id = _data["billing_address_id"];
            this.shipping_option_id = _data["shipping_option_id"];
            this.shipping_amount = _data["shipping_amount"];
            this.total_amount = _data["total_amount"];
            this.tracking_number = _data["tracking_number"];
            this.tracking_url = _data["tracking_url"];
            this.type = _data["type"];
            this.timezone = _data["timezone"];
            this.revision = _data["revision"];
            this.status = _data["status"];
            this.complete_date = _data["complete_date"];
            this.create_date = _data["create_date"];
            this.update_date = _data["update_date"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLine.fromJS(item));
            }
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? UserAddress.fromJS(_data["billingAddress"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? UserAddress.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.shippingOption = _data["shippingOption"] ? ShippingOption.fromJS(_data["shippingOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["external_id"] = this.external_id;
        data["user_id"] = this.user_id;
        data["shipping_address_id"] = this.shipping_address_id;
        data["billing_address_id"] = this.billing_address_id;
        data["shipping_option_id"] = this.shipping_option_id;
        data["shipping_amount"] = this.shipping_amount;
        data["total_amount"] = this.total_amount;
        data["tracking_number"] = this.tracking_number;
        data["tracking_url"] = this.tracking_url;
        data["type"] = this.type;
        data["timezone"] = this.timezone;
        data["revision"] = this.revision;
        data["status"] = this.status;
        data["complete_date"] = this.complete_date;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["shippingOption"] = this.shippingOption ? this.shippingOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrder {
    id?: number;
    external_id?: string | undefined;
    user_id?: number;
    shipping_address_id?: number;
    billing_address_id?: number;
    shipping_option_id?: number;
    shipping_amount?: number;
    total_amount?: number;
    tracking_number?: string;
    tracking_url?: string;
    /** `1` Purchase

`2` Pre-order
 */
    type?: OrderType;
    timezone?: string;
    revision?: number;
    /** `1` Pending approve

`2` Processing

`3` Canceled

`4` Fulfillment error

`5` Pending fulfullment

`6` Fulfilled

`7` Out for delivery

`8` In transit

`9` Completed

`10` Partially returned

`11` Returned
 */
    status?: OrderStatus;
    complete_date?: string | undefined;
    create_date?: string;
    update_date?: string;
    lines?: OrderLine[];
    user?: User;
    billingAddress?: UserAddress;
    shippingAddress?: UserAddress;
    shippingOption?: ShippingOption;

    [key: string]: any;
}

export class OrderLine implements IOrderLine {
    id?: number;
    order_id?: number;
    product_variant_id?: number;
    serial_numbers?: string[] | undefined;
    qty?: number;
    price?: number;
    productVariant?: ProductVariant;

    [key: string]: any;

    constructor(data?: IOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.order_id = _data["order_id"];
            this.product_variant_id = _data["product_variant_id"];
            if (Array.isArray(_data["serial_numbers"])) {
                this.serial_numbers = [] as any;
                for (let item of _data["serial_numbers"])
                    this.serial_numbers!.push(item);
            }
            this.qty = _data["qty"];
            this.price = _data["price"];
            this.productVariant = _data["productVariant"] ? ProductVariant.fromJS(_data["productVariant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["order_id"] = this.order_id;
        data["product_variant_id"] = this.product_variant_id;
        if (Array.isArray(this.serial_numbers)) {
            data["serial_numbers"] = [];
            for (let item of this.serial_numbers)
                data["serial_numbers"].push(item);
        }
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderLine {
    id?: number;
    order_id?: number;
    product_variant_id?: number;
    serial_numbers?: string[] | undefined;
    qty?: number;
    price?: number;
    productVariant?: ProductVariant;

    [key: string]: any;
}

export class Product implements IProduct {
    readonly id?: number;
    readonly product_type_id?: number;
    name?: string;
    slug?: string;
    readonly url?: string;
    readonly image_url?: string | undefined;
    hs_code?: string;
    readonly revision?: number;
    /** `0` Inactive

`1` Active
 */
    status?: ProductStatus;
    readonly create_date?: string;
    readonly update_date?: string;
    productType?: ProductType;
    variants?: ProductVariant[];

    [key: string]: any;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            (<any>this).id = _data["id"];
            (<any>this).product_type_id = _data["product_type_id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            (<any>this).url = _data["url"];
            (<any>this).image_url = _data["image_url"];
            this.hs_code = _data["hs_code"];
            (<any>this).revision = _data["revision"];
            this.status = _data["status"];
            (<any>this).create_date = _data["create_date"];
            (<any>this).update_date = _data["update_date"];
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : <any>undefined;
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(ProductVariant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["product_type_id"] = this.product_type_id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["url"] = this.url;
        data["image_url"] = this.image_url;
        data["hs_code"] = this.hs_code;
        data["revision"] = this.revision;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>undefined;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProduct {
    id?: number;
    product_type_id?: number;
    name?: string;
    slug?: string;
    url?: string;
    image_url?: string | undefined;
    hs_code?: string;
    revision?: number;
    /** `0` Inactive

`1` Active
 */
    status?: ProductStatus;
    create_date?: string;
    update_date?: string;
    productType?: ProductType;
    variants?: ProductVariant[];

    [key: string]: any;
}

export class ProductReserve implements IProductReserve {
    id?: number;
    product_variant_id?: number;
    user_id?: number | undefined;
    user_name?: any;
    user_email?: any;
    /** `0` Canceled

`1` Actives

`2` Notify sent
 */
    status?: ProductReserveStatus;
    create_date?: string;
    productVariant?: ProductVariant;
    user?: User;

    [key: string]: any;

    constructor(data?: IProductReserve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.product_variant_id = _data["product_variant_id"];
            this.user_id = _data["user_id"];
            this.user_name = _data["user_name"];
            this.user_email = _data["user_email"];
            this.status = _data["status"];
            this.create_date = _data["create_date"];
            this.productVariant = _data["productVariant"] ? ProductVariant.fromJS(_data["productVariant"]) : <any>undefined;
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductReserve {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReserve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["product_variant_id"] = this.product_variant_id;
        data["user_id"] = this.user_id;
        data["user_name"] = this.user_name;
        data["user_email"] = this.user_email;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductReserve {
    id?: number;
    product_variant_id?: number;
    user_id?: number | undefined;
    user_name?: any;
    user_email?: any;
    /** `0` Canceled

`1` Actives

`2` Notify sent
 */
    status?: ProductReserveStatus;
    create_date?: string;
    productVariant?: ProductVariant;
    user?: User;

    [key: string]: any;
}

export class ProductType implements IProductType {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IProductType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProductType {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class ProductVariant implements IProductVariant {
    readonly id?: number;
    readonly product_id?: number;
    readonly country_id?: number;
    readonly uom_id?: number;
    title?: string;
    full_title?: string;
    readonly image_url?: string | undefined;
    price?: number;
    compare_at_price?: number;
    readonly stock_qty?: number;
    readonly preordered_qty?: number;
    max_preorder_qty?: number;
    sku?: string;
    barcode?: string;
    readonly weight?: number;
    readonly sort?: number;
    readonly revision?: number;
    /** `1` Purchase

`2` Pre-order

`3` Reserve
 */
    sale_policy?: ProductVariantSale_policy;
    /** `0` Inactive

`1` Active
 */
    status?: ProductVariantStatus;
    readonly create_date?: string;
    readonly update_date?: string;
    country?: Country;
    product?: Product;
    uom?: Uom;

    [key: string]: any;

    constructor(data?: IProductVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            (<any>this).id = _data["id"];
            (<any>this).product_id = _data["product_id"];
            (<any>this).country_id = _data["country_id"];
            (<any>this).uom_id = _data["uom_id"];
            this.title = _data["title"];
            this.full_title = _data["full_title"];
            (<any>this).image_url = _data["image_url"];
            this.price = _data["price"];
            this.compare_at_price = _data["compare_at_price"];
            (<any>this).stock_qty = _data["stock_qty"];
            (<any>this).preordered_qty = _data["preordered_qty"];
            this.max_preorder_qty = _data["max_preorder_qty"];
            this.sku = _data["sku"];
            this.barcode = _data["barcode"];
            (<any>this).weight = _data["weight"];
            (<any>this).sort = _data["sort"];
            (<any>this).revision = _data["revision"];
            this.sale_policy = _data["sale_policy"];
            this.status = _data["status"];
            (<any>this).create_date = _data["create_date"];
            (<any>this).update_date = _data["update_date"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.uom = _data["uom"] ? Uom.fromJS(_data["uom"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductVariant {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["product_id"] = this.product_id;
        data["country_id"] = this.country_id;
        data["uom_id"] = this.uom_id;
        data["title"] = this.title;
        data["full_title"] = this.full_title;
        data["image_url"] = this.image_url;
        data["price"] = this.price;
        data["compare_at_price"] = this.compare_at_price;
        data["stock_qty"] = this.stock_qty;
        data["preordered_qty"] = this.preordered_qty;
        data["max_preorder_qty"] = this.max_preorder_qty;
        data["sku"] = this.sku;
        data["barcode"] = this.barcode;
        data["weight"] = this.weight;
        data["sort"] = this.sort;
        data["revision"] = this.revision;
        data["sale_policy"] = this.sale_policy;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["uom"] = this.uom ? this.uom.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductVariant {
    id?: number;
    product_id?: number;
    country_id?: number;
    uom_id?: number;
    title?: string;
    full_title?: string;
    image_url?: string | undefined;
    price?: number;
    compare_at_price?: number;
    stock_qty?: number;
    preordered_qty?: number;
    max_preorder_qty?: number;
    sku?: string;
    barcode?: string;
    weight?: number;
    sort?: number;
    revision?: number;
    /** `1` Purchase

`2` Pre-order

`3` Reserve
 */
    sale_policy?: ProductVariantSale_policy;
    /** `0` Inactive

`1` Active
 */
    status?: ProductVariantStatus;
    create_date?: string;
    update_date?: string;
    country?: Country;
    product?: Product;
    uom?: Uom;

    [key: string]: any;
}

export class Review implements IReview {
    id?: number;
    product_id?: number;
    user_id?: number | undefined;
    title?: any;
    review_text?: any;
    star_count?: number;
    /** `0` Deleted

`1` New on modaration

`2` Published

`3` Spam
 */
    status?: ReviewStatus;
    create_date?: string;
    update_date?: string;
    product?: Product;
    user?: User;
    avatar?: Avatar;
    attachments?: ReviewAttachment[];

    [key: string]: any;

    constructor(data?: IReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.product_id = _data["product_id"];
            this.user_id = _data["user_id"];
            this.title = _data["title"];
            this.review_text = _data["review_text"];
            this.star_count = _data["star_count"];
            this.status = _data["status"];
            this.create_date = _data["create_date"];
            this.update_date = _data["update_date"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.avatar = _data["avatar"] ? Avatar.fromJS(_data["avatar"]) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ReviewAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Review {
        data = typeof data === 'object' ? data : {};
        let result = new Review();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["product_id"] = this.product_id;
        data["user_id"] = this.user_id;
        data["title"] = this.title;
        data["review_text"] = this.review_text;
        data["star_count"] = this.star_count;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReview {
    id?: number;
    product_id?: number;
    user_id?: number | undefined;
    title?: any;
    review_text?: any;
    star_count?: number;
    /** `0` Deleted

`1` New on modaration

`2` Published

`3` Spam
 */
    status?: ReviewStatus;
    create_date?: string;
    update_date?: string;
    product?: Product;
    user?: User;
    avatar?: Avatar;
    attachments?: ReviewAttachment[];

    [key: string]: any;
}

export class ReviewAttachment implements IReviewAttachment {
    id?: number;
    review_id?: number;
    preview_url?: string;
    source_url?: string;
    duration?: number;
    /** `1` Image
`2` Video
 */
    type?: ReviewAttachmentType;
    /** `0` Deleted

`1` Active

`2` Processing
 */
    status?: ReviewAttachmentStatus;

    [key: string]: any;

    constructor(data?: IReviewAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.review_id = _data["review_id"];
            this.preview_url = _data["preview_url"];
            this.source_url = _data["source_url"];
            this.duration = _data["duration"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReviewAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["review_id"] = this.review_id;
        data["preview_url"] = this.preview_url;
        data["source_url"] = this.source_url;
        data["duration"] = this.duration;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IReviewAttachment {
    id?: number;
    review_id?: number;
    preview_url?: string;
    source_url?: string;
    duration?: number;
    /** `1` Image
`2` Video
 */
    type?: ReviewAttachmentType;
    /** `0` Deleted

`1` Active

`2` Processing
 */
    status?: ReviewAttachmentStatus;

    [key: string]: any;
}

export class ShippingOption implements IShippingOption {
    id?: number;
    courier_id?: number | undefined;
    name?: string;
    display_name?: string;
    title?: string;
    courier?: Courier;

    [key: string]: any;

    constructor(data?: IShippingOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.courier_id = _data["courier_id"];
            this.name = _data["name"];
            this.display_name = _data["display_name"];
            this.title = _data["title"];
            this.courier = _data["courier"] ? Courier.fromJS(_data["courier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShippingOption {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["courier_id"] = this.courier_id;
        data["name"] = this.name;
        data["display_name"] = this.display_name;
        data["title"] = this.title;
        data["courier"] = this.courier ? this.courier.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShippingOption {
    id?: number;
    courier_id?: number | undefined;
    name?: string;
    display_name?: string;
    title?: string;
    courier?: Courier;

    [key: string]: any;
}

export class User implements IUser {
    id?: number;
    name?: string;
    last_name?: string;
    email?: string;
    revision?: number;
    /** `0` Deleted

`1` Active

`2` Not confirmed

`3` Not completed

`4` Banned
 */
    status?: UserStatus;
    create_date?: string;
    update_date?: string;
    addresses?: UserAddress[];
    userCards?: UserCard[];

    [key: string]: any;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.last_name = _data["last_name"];
            this.email = _data["email"];
            this.revision = _data["revision"];
            this.status = _data["status"];
            this.create_date = _data["create_date"];
            this.update_date = _data["update_date"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(UserAddress.fromJS(item));
            }
            if (Array.isArray(_data["userCards"])) {
                this.userCards = [] as any;
                for (let item of _data["userCards"])
                    this.userCards!.push(UserCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["last_name"] = this.last_name;
        data["email"] = this.email;
        data["revision"] = this.revision;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.userCards)) {
            data["userCards"] = [];
            for (let item of this.userCards)
                data["userCards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUser {
    id?: number;
    name?: string;
    last_name?: string;
    email?: string;
    revision?: number;
    /** `0` Deleted

`1` Active

`2` Not confirmed

`3` Not completed

`4` Banned
 */
    status?: UserStatus;
    create_date?: string;
    update_date?: string;
    addresses?: UserAddress[];
    userCards?: UserCard[];

    [key: string]: any;
}

export class UserCard implements IUserCard {
    id?: number;
    user_id?: number;
    num?: string;
    mm?: number;
    yy?: number;
    /** `0` Unknown

`1` Debit

`2` Credit

`3` Prepaid
 */
    funding_type?: UserCardFunding_type;
    /** `0` Unknown

`1` Electron

`2` Interpayment

`3` Unionpay

`4` Discover

`5` Maestro

`6` Visa

`7` Mastercard

`8` Amex

`9` Diners

`10` JCB

`11` Mir
 */
    card_brand_id?: UserCardCard_brand_id;
    /** `0` Deleted

`1` Active
 */
    status?: UserCardStatus;
    create_date?: string;

    [key: string]: any;

    constructor(data?: IUserCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.num = _data["num"];
            this.mm = _data["mm"];
            this.yy = _data["yy"];
            this.funding_type = _data["funding_type"];
            this.card_brand_id = _data["card_brand_id"];
            this.status = _data["status"];
            this.create_date = _data["create_date"];
        }
    }

    static fromJS(data: any): UserCard {
        data = typeof data === 'object' ? data : {};
        let result = new UserCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["num"] = this.num;
        data["mm"] = this.mm;
        data["yy"] = this.yy;
        data["funding_type"] = this.funding_type;
        data["card_brand_id"] = this.card_brand_id;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        return data;
    }
}

export interface IUserCard {
    id?: number;
    user_id?: number;
    num?: string;
    mm?: number;
    yy?: number;
    /** `0` Unknown

`1` Debit

`2` Credit

`3` Prepaid
 */
    funding_type?: UserCardFunding_type;
    /** `0` Unknown

`1` Electron

`2` Interpayment

`3` Unionpay

`4` Discover

`5` Maestro

`6` Visa

`7` Mastercard

`8` Amex

`9` Diners

`10` JCB

`11` Mir
 */
    card_brand_id?: UserCardCard_brand_id;
    /** `0` Deleted

`1` Active
 */
    status?: UserCardStatus;
    create_date?: string;

    [key: string]: any;
}

export class UserAddress implements IUserAddress {
    id?: number;
    user_id?: number;
    title?: string;
    country_id?: number;
    area_id?: number;
    locality_id?: number;
    zip?: string;
    company?: string;
    street?: string;
    suite?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    lat?: number;
    lng?: number;
    saved?: UserAddressSaved;
    /** `0` Deleted

`1` Active
 */
    status?: UserAddressStatus;
    create_date?: string;
    update_date?: string;
    area?: Area;
    country?: Country;
    locality?: Locality;

    [key: string]: any;

    constructor(data?: IUserAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.user_id = _data["user_id"];
            this.title = _data["title"];
            this.country_id = _data["country_id"];
            this.area_id = _data["area_id"];
            this.locality_id = _data["locality_id"];
            this.zip = _data["zip"];
            this.company = _data["company"];
            this.street = _data["street"];
            this.suite = _data["suite"];
            this.phone = _data["phone"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.saved = _data["saved"];
            this.status = _data["status"];
            this.create_date = _data["create_date"];
            this.update_date = _data["update_date"];
            this.area = _data["area"] ? Area.fromJS(_data["area"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.locality = _data["locality"] ? Locality.fromJS(_data["locality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["user_id"] = this.user_id;
        data["title"] = this.title;
        data["country_id"] = this.country_id;
        data["area_id"] = this.area_id;
        data["locality_id"] = this.locality_id;
        data["zip"] = this.zip;
        data["company"] = this.company;
        data["street"] = this.street;
        data["suite"] = this.suite;
        data["phone"] = this.phone;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["saved"] = this.saved;
        data["status"] = this.status;
        data["create_date"] = this.create_date;
        data["update_date"] = this.update_date;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["locality"] = this.locality ? this.locality.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserAddress {
    id?: number;
    user_id?: number;
    title?: string;
    country_id?: number;
    area_id?: number;
    locality_id?: number;
    zip?: string;
    company?: string;
    street?: string;
    suite?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    lat?: number;
    lng?: number;
    saved?: UserAddressSaved;
    /** `0` Deleted

`1` Active
 */
    status?: UserAddressStatus;
    create_date?: string;
    update_date?: string;
    area?: Area;
    country?: Country;
    locality?: Locality;

    [key: string]: any;
}

export class Uom implements IUom {
    id?: number;
    name?: string;
    short_name?: string;

    [key: string]: any;

    constructor(data?: IUom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.short_name = _data["short_name"];
        }
    }

    static fromJS(data: any): Uom {
        data = typeof data === 'object' ? data : {};
        let result = new Uom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["short_name"] = this.short_name;
        return data;
    }
}

export interface IUom {
    id?: number;
    name?: string;
    short_name?: string;

    [key: string]: any;
}

export class _Meta implements I_Meta {
    totalCount?: number;
    pageCount?: number;
    currentPage?: number;
    perPage?: number;
    sort?: string;

    [key: string]: any;

    constructor(data?: I_Meta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalCount = _data["totalCount"];
            this.pageCount = _data["pageCount"];
            this.currentPage = _data["currentPage"];
            this.perPage = _data["perPage"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): _Meta {
        data = typeof data === 'object' ? data : {};
        let result = new _Meta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["perPage"] = this.perPage;
        data["sort"] = this.sort;
        return data;
    }
}

export interface I_Meta {
    totalCount?: number;
    pageCount?: number;
    currentPage?: number;
    perPage?: number;
    sort?: string;

    [key: string]: any;
}

export class HttpException implements IHttpException {
    name?: string;
    message?: string;
    code?: number;
    status?: number;
    type?: string;

    [key: string]: any;

    constructor(data?: IHttpException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.message = _data["message"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): HttpException {
        data = typeof data === 'object' ? data : {};
        let result = new HttpException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["message"] = this.message;
        data["code"] = this.code;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IHttpException {
    name?: string;
    message?: string;
    code?: number;
    status?: number;
    type?: string;

    [key: string]: any;
}

export enum Expand {
    Areas = "areas",
}

export enum Expand2 {
    Lines = "lines",
    User = "user",
    ShippingAddress = "shippingAddress",
    BillingAddress = "billingAddress",
    ShippingOption = "shippingOption",
}

export enum Expand3 {
    Lines = "lines",
    User = "user",
    ShippingAddress = "shippingAddress",
    BillingAddress = "billingAddress",
    ShippingOption = "shippingOption",
}

export enum Expand4 {
    ProductType_variants = "productType,variants",
}

export enum Expand5 {
    ProductType_variants = "productType,variants",
}

export enum Expand6 {
    Country = "country",
    Uom = "uom",
    Product = "product",
    Country_uom_product = "country,uom,product",
}

export enum Expand7 {
    Product_user_avatar_attachments = "product,user,avatar,attachments",
}

export class Body implements IBody {
    status!: BodyStatus;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IBody {
    status: BodyStatus;

    [key: string]: any;
}

export enum Expand8 {
    User_productVariant = "user,productVariant",
}

export enum Expand9 {
    Addresses_userCards = "addresses,userCards",
}

export enum Expand10 {
    Addresses = "addresses",
    UserCards = "userCards",
    Addresses_userCards = "addresses,userCards",
}

export class Anonymous implements IAnonymous {
    items?: Country[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Country.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous {
    items?: Country[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {
    items?: Order[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Order.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous2 {
    items?: Order[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous3 implements IAnonymous3 {
    items?: Product[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Product.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous3 {
    items?: Product[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous4 implements IAnonymous4 {
    items?: Review[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Review.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous4 {
    items?: Review[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous5 implements IAnonymous5 {
    items?: Uom[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Uom.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous5 {
    items?: Uom[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous6 implements IAnonymous6 {
    items?: ProductReserve[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductReserve.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous6 {
    items?: ProductReserve[];
    _meta?: _Meta;

    [key: string]: any;
}

export class Anonymous7 implements IAnonymous7 {
    items?: User[];
    _meta?: _Meta;

    [key: string]: any;

    constructor(data?: IAnonymous7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(User.fromJS(item));
            }
            this._meta = _data["_meta"] ? _Meta.fromJS(_data["_meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous7 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnonymous7 {
    items?: User[];
    _meta?: _Meta;

    [key: string]: any;
}

export enum OrderType {
    _1 = 1,
    _2 = 2,
}

export enum OrderStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export enum ProductStatus {
    _0 = 0,
    _1 = 1,
}

export enum ProductReserveStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ProductVariantSale_policy {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ProductVariantStatus {
    _0 = 0,
    _1 = 1,
}

export enum ReviewStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ReviewAttachmentType {
    _1 = 1,
    _2 = 2,
}

export enum ReviewAttachmentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum UserStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum UserCardFunding_type {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum UserCardCard_brand_id {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export enum UserCardStatus {
    _0 = 0,
    _1 = 1,
}

export enum UserAddressSaved {
    _0 = 0,
    _1 = 1,
}

export enum UserAddressStatus {
    _0 = 0,
    _1 = 1,
}

export enum BodyStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
